import {
  ApiCartChangeCartStoreFailedAction,
  ApiCartChangeCartStoreSucceededAction,
  apiCartChangeCartStoreFailedType,
  apiCartChangeCartStoreRequested,
  apiCartChangeCartStoreSucceededType
} from '@spa/lib/store/api/cart/changeCartStoreApi';
import {
  ChangeCurrentCartSelectedStoreRequestedAction,
  changeCurrentCartSelectedStoreFailed,
  changeCurrentCartSelectedStoreSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartStoreResult } from '@spa/lib/graphql/cart/changeCartStore';
import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartSelectedStoreSaga({
  payload: { actionId: requestedActionId, storeCode }
}: ChangeCurrentCartSelectedStoreRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartStoreRequested({
      actionId,
      storeCode,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId);
}

function* actionsLoop(actionId: number, requestedActionId: number): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartStoreSucceededAction>(apiCartChangeCartStoreSucceededType),
      failed: take<ApiCartChangeCartStoreFailedAction>(apiCartChangeCartStoreFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const result: ChangeCartStoreResult = succeeded.payload.result;
        if (result.__typename === 'ChangeCartStoreFailedResult') {
          yield* put(
            changeCurrentCartSelectedStoreFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartSelectedStoreSucceeded({
              cart: convertCartToStateCart(result.cart),
              customOrderType: CustomOrderType.COLLECT_AT_STORE,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartSelectedStoreFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartSelectedStoreSaga;
